import { ConnectedOverlayScrollHandler } from 'primeng/dom'
import { filter, Subject, Subscription, throttleTime } from 'rxjs'

/**
 * Hotfix: Enhanced PrimeNG ConnectedOverlayScrollHandler
 *
 * By default, ConnectedOverlayScrollHandler detects scroll events only on parent elements.
 * This fix ensures that scroll events are detected globally while ignoring those occurring inside overlays.
 */

const globalScroll$ = new Subject<Event>()
const subscriptionMap = new WeakMap<object, Subscription>()

export function patchConnectedOverlayScroll() {
  /**
   * Hotfix: Enhanced PrimeNG ConnectedOverlayScrollHandler
   *
   * By default, ConnectedOverlayScrollHandler detects scroll events only on parent elements.
   * This fix ensures that scroll events are detected globally while ignoring those occurring inside overlays.
   */

  // Ignore scroll inside PrimeNg overlays
  const ignoredElementSelector = [
    '.p-menu-overlay',
    '.p-overlay',
    '.p-overlaypanel',
    '.p-popover',
  ].join(', ')

  ConnectedOverlayScrollHandler.prototype.bindScrollListener = function () {
    subscriptionMap.set(
      this,
      globalScroll$
        .pipe(
          // Only the browser scrolls the document (html/body have overflow: hidden), e.g. iOS
          // revealing a focused field above the keyboard and scrolling back. Filtered before the
          // throttle so ignored events can't take an element scroll's trailing slot.
          filter((e) => e.target instanceof Element && !e.target.closest(ignoredElementSelector)),
          throttleTime(256, undefined, { trailing: true }),
        )
        .subscribe((e) => this.listener?.(e)),
    )
  }

  ConnectedOverlayScrollHandler.prototype.unbindScrollListener = function () {
    subscriptionMap.get(this)?.unsubscribe()
  }

  // Global scroll event listener in capture mode
  document.addEventListener('scroll', (e) => globalScroll$.next(e), true)
}
